import farmaciasService from "../services/farmacias.service";

const initialState = { 
  farmacia: null,
  provinciaSeleccionada: null,
  concelloSeleccionado: null,
  concellos: [],
  farmacias: []
};

export const farmacias = {
  namespaced: true,
  state: initialState,
  actions: {
    async estadisticas(context, object) {
      return await farmaciasService.estadisticas(object);
    },
  },
};
